var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenhours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11702 9.80723C4.55447 13.7925 2.56186 18.9249 2.50148 24.2587C2.36058 36.4559 12.3237 46.4592 24.5007 46.4995C36.6778 46.5196 46.5 36.6572 46.5 24.5002C46.5 12.5244 36.9193 2.76263 25.0039 2.50098C24.9435 2.50098 24.863 2.50098 24.8026 2.54123C24.7423 2.56136 24.6819 2.60161 24.6416 2.64187C24.6014 2.68212 24.5611 2.74251 24.5209 2.80289C24.5007 2.86327 24.4806 2.92365 24.4806 3.00416V12.5848",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9263 27.0762L12.869 14.1342C12.7281 13.9531 12.6879 13.7317 12.708 13.5103C12.7281 13.2889 12.8086 13.0876 12.9696 12.9266C13.1307 12.7656 13.3319 12.6851 13.5533 12.6649C13.7546 12.6448 13.976 12.7052 14.1572 12.826L27.0991 21.8833C27.8841 22.4469 28.4275 23.3123 28.5885 24.2785C28.7495 25.2446 28.5281 26.2308 27.9646 27.0359C27.401 27.841 26.5556 28.3845 25.5895 28.5656C24.6234 28.7467 23.6372 28.5253 22.8321 27.9819C22.4899 27.7404 22.1679 27.4385 21.9263 27.0762Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenhours);
export default __webpack_public_path__ + "static/media/openhours.b10fc8a2c08bdd38840da00abb58f282.svg";
export { ForwardRef as ReactComponent };